<template>
    <module-card>
        <div v-if="needsWork.length > 0">
            <p>You said you needed to work on the following strategies:</p>
            <ul>
                <li v-for="(strategy, index) in needsWork" :key="index">{{ strategy.strategy }}</li>
            </ul>
        </div>
        <div v-else>
            <p>Look at you and your confident self!</p>
        </div>
        <p>Remember, you’re worth protecting! Practice assertive communication techniques whenever you can – which will help you in sexy situations too! The more you do it, the more it becomes a habit!</p>
    </module-card>
</template>

<script>
    import { filter } from 'lodash';

    export default {
        computed: {
            needsWork() {
                let arr = [];

                arr = filter(this.$store.get(`peepInLoveCommunicationStrategies`), (o) => {
                    return o.response === 3;
                });

                return arr;
            }
        }
    };
</script>
